/*
 * Copyright (c) 2020. Dave van Rijn Development
 */
import './style/ytDownload.scss';

import React, {MouseEventHandler, PureComponent} from 'react';
import {Button, ChangeFunction, Loader, TextField} from '@dvrd/dvr-controls';

interface Props {
    onChangeUrl: ChangeFunction<string>;
    onDownload: MouseEventHandler;
    url: string;
    loading: boolean;
}

export default class YtDownload extends PureComponent<Props> {
    onEnter = (evt: any) => {
        this.props.onDownload(evt);
    };

    render = () => {
        const {url, onChangeUrl, onDownload, loading} = this.props;
        return (
            <div className='yt-downloader'>
                <div className='top-bar'>
                    <label className='header-title'>Muziek downloaden</label>
                </div>
                <div className='body-container'>
                    <div className='body-items-container'>
                        <label className='desc'>Plak een Youtube URL hieronder in het veld en klik op Downloaden om de
                            muziek te downloaden.</label>
                        <div className='field-container'>
                            <TextField value={url} onChange={onChangeUrl} label='Youtube URL' onEnter={this.onEnter}
                                       className='url-field' fullWidth/>
                            {loading ? <Loader active containerClass='download-loader' size='2rem'/> :
                                <Button onClick={onDownload} label='Downloaden' disabled={!url.length}/>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}